import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Button from '@components/shared/Button';
import Colors from '@components/shared/Colors';
import TamponBoxConfig from '@components/dashboard/TamponBoxConfig';
import { BoxState } from '@contracts';
import TamponSelectionModal from './TamponSelectionModal';

interface Props {
  boxStateOuter: BoxState;
  setBoxStateOuter: (value: BoxState) => void;
}

const TamponSelection: React.FC<Props> = ({ boxStateOuter, setBoxStateOuter }) => {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);
  const [boxState, setBoxState] = useState<BoxState>(boxStateOuter);

  return (
    <Container>
      <Tabs onClick={() => setModalOpen(true)}>
        <Tab selected={boxState.boxSize === 12}>{t('components.tampon-boxes.12-tampons')}</Tab>
        <Tab selected={boxState.boxSize === 18}>{t('components.tampon-boxes.18-tampons')}</Tab>
      </Tabs>
      <BoxConfiguration onClick={() => setModalOpen(true)}>
        <TamponBoxConfig variants={boxState} />
      </BoxConfiguration>
      <ButtonStyled onClick={() => setModalOpen(true)}>{t('components.choose-box')}</ButtonStyled>
      <TamponSelectionModal
        isOpen={isModalOpen}
        closeModal={() => setModalOpen(false)}
        boxState={boxState}
        setBoxState={(value) => setBoxState(value)}
        setBoxStateOuter={(value) => setBoxStateOuter(value)}
      />
    </Container>
  );
};

export default TamponSelection;

interface StyleProps {
  color?: string;
  textColor?: string;
  selected?: boolean;
}

const Container = styled.div`
  color: ${Colors.forestGreen};
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Tabs = styled.div`
  color: ${Colors.forestGreen};
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 40px;
  border: 1px solid ${Colors.paleGold};
  border-bottom-color: ${Colors.ecru};
`;

const Tab = styled.button<StyleProps>`
  color: ${Colors.forestGreen};
  all: unset;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  border-bottom: 3px solid ${(props) => (props.selected ? Colors.gold : Colors.ecru)};

  font-family: BrownStd;
  font-size: 14px;
  font-weight: ${(props) => (props.selected ? '700' : '400')};
  line-height: 17px;
  text-align: center;
`;

const BoxConfiguration = styled.div``;

const ButtonStyled = styled(Button)`
  color: ${Colors.forestGreen};
  background: ${Colors.paleGold};

  &:hover {
    background: ${Colors.lilac} !important;
  }
`;
